import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {AbstractRESTService} from "./abstract.rest.service";
import {Router} from "@angular/router";

@Injectable()
export class AuthRESTService extends AbstractRESTService {

    constructor(http: HttpClient, router: Router) {
        super(http, environment.restUrl, router)
    }

    protected createCustomHeaders(): any {
        return {
            headers: new HttpHeaders({'Authorization': 'Bearer ' +localStorage.getItem("tokenJWT")}),
        };
    }
}
